import { render, staticRenderFns } from "./StaPers.vue?vue&type=template&id=1570eb57&scoped=true&"
import script from "./StaPers.vue?vue&type=script&lang=js&"
export * from "./StaPers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1570eb57",
  null
  
)

export default component.exports